import { useEffect, useRef, useState } from 'react'
import Feather from '@sysunite/react-feather'
import { Row, Col, Tooltip, Button } from 'antd'
import './GraphLayout.scss'

GraphLayout = ({ onSetHierarchical = -> }) ->
  directions = {
    UD: { title: 'Up-Down', icon: 'arrow-down' }
    DU: { title: 'Down-Up', icon: 'arrow-up' }
    RL: { title: 'Right-Left', icon: 'arrow-left' }
    LR: { title: 'Left-Right', icon: 'arrow-right' }
  }

  [active, setActive] = useState(false)
  [direction, setDirection] = useState('UD')
  [tooltipVisible, setTooltipVisible] = useState(false)

  classNames = ['graph-layout']

  if active
    classNames.push('is-open')

  useEffect(->
    if active
      onSetHierarchical({
        direction
        sortMethod: 'directed'
        nodeSpacing: 150
      })
    else
      onSetHierarchical(active)
    undefined
  , [active, direction])

  <div className={classNames.join(' ')}>
    <Row>
      <Col>
        <Tooltip
          placement="bottomLeft"
          trigger="hover"
          mouseEnterDelay={1}
          visible={not active and tooltipVisible}
          onVisibleChange={setTooltipVisible}
          title="Set hierarchical layout">
            <Button
              onClick={->
                setActive(not active)
              }
              className={active && 'active'}
              type="link"
              icon={<Feather size="1.5em" style={{ transform: 'rotate(90deg)' }} type="share-2" />}        />
        </Tooltip>
      </Col>
      {
        if active
          <Col className="layouts" flex>
            {
              _.map(directions, ({ title, icon }, key) ->
                <Tooltip
                  placement="bottomLeft"
                  trigger="hover"
                  mouseEnterDelay={1}
                  key={key}
                  title={title}>
                  <Button
                    onClick={->
                      setDirection(key)
                    }
                    className={'active' if direction is key}
                    type="link"
                    icon={<Feather size="1.5em" type={icon} />} />
                </Tooltip>
              )
            }
          </Col>
      }
    </Row>
  </div>

export default GraphLayout
